import { Moon as Moon_kojaro } from './Moon.kojaro';
import { Moon as Moon_phosphor } from './Moon.phosphor';
import { Moon as Moon_zoomg } from './Moon.zoomg';
import { Moon as Moon_zoomit } from './Moon.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Moon_kojaro;

    case 'zoomg':
      return Moon_zoomg;

    case 'phosphor':
      return Moon_phosphor;

    default:
      return Moon_zoomit;
  }
};

export const Moon = IconRenderer();
